import { api } from '@/lib/api/client'
import type { ApiProduct, PaginatedProducts, ListProductsQuery, CreateProductInput, UpdateProductInput } from '../model/types'

function toQuery(q: ListProductsQuery): string {
  const p = new URLSearchParams()
  if (q.page)         p.set('page', String(q.page))
  if (q.limit)        p.set('limit', String(q.limit))
  if (q.q)            p.set('q', q.q)
  if (q.categorySlug) p.set('categorySlug', q.categorySlug)
  if (q.brand)        p.set('brand', q.brand)
  if (q.minPrice !== undefined) p.set('minPrice', String(q.minPrice))
  if (q.maxPrice !== undefined) p.set('maxPrice', String(q.maxPrice))
  if (q.inStock !== undefined)  p.set('inStock', String(q.inStock))
  if (q.sort)         p.set('sort', q.sort)
  return p.toString()
}

export const productsApi = {
  list(query: ListProductsQuery = {}) {
    const qs = toQuery(query)
    return api.get<PaginatedProducts>(`/products${qs ? '?' + qs : ''}`)
  },
  bySlug(slug: string) {
    return api.get<{ product: ApiProduct; related: ApiProduct[] }>(`/products/slug/${slug}`)
  },
  brands() { return api.get<string[]>('/products/brands') },
  create(input: CreateProductInput) { return api.post<ApiProduct>('/products', input) },
  update(id: string, input: UpdateProductInput) { return api.patch<ApiProduct>(`/products/${id}`, input) },
  remove(id: string) { return api.delete<{ ok: boolean }>(`/products/${id}`) },
}
